import {useParams} from 'react-router-dom'

import styles from './ProjectDrawdownsStats.module.scss'
import {MeterStat} from 'common/components'
import {formatMoney} from 'common/helpers'
import {DrawdownsChart, useGetProject} from '..'

/**
 * Drawdown 整体指标数据展示
 * @returns 
 */
export default function ProjectDrawdownsStats() {
  const params = useParams()
  const {data: project} = useGetProject(params.uuid)

  return (
    <div className={styles.root}>
      <MeterStat
        large
        type="black"
        title="Loan withdrawal"
        value={formatMoney(project.withdrawn, {cents: true})}
        label={`${formatMoney(project.availableWithdrawal, {
          cents: true,
        })} available`}
      />
      <MeterStat
        greyTitle
        large
        type="dotsBlack"
        title="Pending drawdown"
        value={formatMoney(project.withdrawPending, {cents: true})}
        label="&nbsp;"
      />
      <DrawdownsChart project={project} />
      <MeterStat
        large
        right
        type="transparent"
        title="Loan"
        value={formatMoney(project.facilityLimit1, {cents: true})}
        label="excluding interest & fees"
      />
    </div>
  )
}
